export default {
	title: '算法模型配置',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		modelConfig: '模型配置',
		configHistory: '配置历史',
		addHealthCalculation: '添加健康度计算',
		start: '启动',
		stop: '停止',
		refreshAlgorithmModel: '刷新算法模型'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		setSuccess: '设置成功',
		configSuccess: '配置成功',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		noConfigHistory: '暂无配置历史',
		confirmAddHealthCalculation: '确定要添加健康度计算吗？',
		confirmRefreshAlgorithmModel: '确定要刷新算法模型吗？此操作将重新生成模型配置。',
		confirmAdd: '确认添加',
		confirmRefresh: '确认刷新',
		addHealthCalculationSuccess: '添加健康度计算成功',
		refreshAlgorithmModelSuccess: '刷新算法模型成功',
		getConfigHistoryError: '获取明细数据失败'
	},
	form: {
		deviceName: '所属设备',
		pointNo: '测点编号',
		code: '模型组编码',
		name: '模型组名称',
		mmcodeList: '选择模型',
		sys: '选择特征值',
		placeholder: {
			deviceName: '请输入所属设备',
			pointNo: '请输入测点编号',
			code: '请输入模型组编码',
			name: '请输入模型组名称'
		}
	},
	table: {
		projNo: '项目编号',
		deviceName: '所属设备',
		deviceNo: '设备编号',
		sensorName: '所属测点',
		pointNo: '测点编号',
		name: '名称',
		mtype: '模型类型',
		mmcode: '模型编码',
		eigenKey: '特征值',
		isEnable: '是否启用'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		modelConfigTitle: '模型配置',
		configHistoryTitle: '配置历史'
	},
	gridLayout: '格栅布局',
	columns: {
		deviceName: '设备名称',
		sensorName: '测点名称',
		modelGroupName: '模型组名称',
		modelCode: '模型代码',
		modelName: '模型名称',
		isEnabled: '是否启用',
		action: '操作'
	},
	config: {
		selectDevice: '选择设备',
		selectSensor: '选择测点',
		selectAlgorithmGroup: '算法模型组',
		paramType: '参数类型',
		paramValue: '参数值',
		paramDesc: '参数描述',
		configParam: '配置参数',
		configTime: '配置时间'
	},
	detailConfig: {
		title: '详细配置',
		expandTitle: '{pointNo} - {sensorName} - 详细配置'
	}
}
